var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
/* Template for rendering 'prev' chevron in pagination

    isCurrentFirst: if currently shown page is the first one

 */
__p+='\n\n';

  let {
    isCurrentFirst
  } = options;

__p+='\n\n<span class="prev">\n  '+
((__t=( isCurrentFirst ? '' : '<a class="prev" data-omtag = "srp:paging:prev">'))==null?'':__t)+
'<i class=\'ra ra-chevron-left\'></i><span></span>'+
((__t=( isCurrentFirst? '' : '</a>'))==null?'':__t)+
'\n</span>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/pagination/prev_page.jst.ejs